<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :actions="actions"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      ref="grid"
      :selectionEnabled="false"
    ></dx-grid>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.title,
    };
  },
  data: () => ({
    url: "",
    title: "ManageEngine Sites",
    actions: [],
    columns: [
      {
        label: "Id",
        field: "id",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Region Name",
        field: "regionName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Region Id",
        field: "regionId",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Is Default",
        field: "isDefault",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  created() {
    this.actions.push({
      text: "Sync Sites",
      action: this.syncSites,
    });
    this.actions.push({
      text: "Edit Sites on ManageEngine",
      action: this.openManageEngineSites,
    });
  },
  methods: {
    async syncSites() {
      try {
        await this.$http.post(
          "api/ManageengineSites/SyncManageEngineSites"
        );
      } catch (error) {
        this.$notify({
          group: "notification",
          text: "Error syncing sites",
          type: "error",
        });
        return;
      }
      this.$refs.grid.reloadGrid();
      this.$notify({
        group: "notification",
        text: "Sites synced successfully",
        type: "success",
      });
    },
    async beforeSetupGrid() {
      this.url = "ManageengineSites";
    },
    openManageEngineSites() {
      window.open(
        "https://utaw.sdpondemand.manageengine.com/app/itdesk/AdminDetails.cc?forwardTo=site",
        "_blank"
      );
    },
  },
};
</script>
